export const CLICK = 'click';
export const LOGIN_SMSCODE = 'log-in-smscode';
export const FIRST_TRANSFER = 'first_transfer';

// dataLayer params
export const GT_USER_ID = 'user_id';
export const GT_SEND_CURRENCY = 'send-currency';
export const GT_AMOUNT_SEND_CURRENCY = 'amount-send-currency';
export const GT_SENDING_COUNTRY_CODE = 'sending-country-code';
export const GT_RECEIVING_COUNTRY_CODE = 'receiving-country-code';
export const GT_TRX_ID = 'trx-id';
export const GT_SENDER_BALID = 'sender_balID';
export const GT_TRANSACTION_ID = 'transaction_ID';
export const GT_RECEIVING_COUNTRY = 'receiving_country';
export const GT_SECTION_CLICKED = 'section_clicked';
